module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/for-sale-property-pin-a683fb0572c0955303f016bdac2b57cc.svg";